package com.swetdot.swetgram.ui

import androidx.compose.animation.core.MutableTransitionState
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInHorizontally
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutHorizontally
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.WindowInsetsSides
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.only
import androidx.compose.foundation.layout.safeDrawing
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.lifecycle.Lifecycle
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.lifecycle.viewmodel.compose.viewModel
import androidx.navigation.NavHostController
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import androidx.navigation.compose.currentBackStackEntryAsState
import androidx.navigation.compose.rememberNavController
import androidx.savedstate.read
import com.swetdot.swetgram.ui.text.resolve
import com.swetdot.swetgram.ui.text.resolveOrNull
import com.swetdot.swetgram.AppContainer
import com.swetdot.swetgram.domain.ChatId
import com.swetdot.swetgram.domain.DiscoverFeedId
import com.swetdot.swetgram.domain.DiscoverPost
import com.swetdot.swetgram.domain.DiscoverPostId
import com.swetdot.swetgram.domain.DiscoverPostType
import com.swetdot.swetgram.domain.GroupId
import com.swetdot.swetgram.domain.DailyTaskDestination
import com.swetdot.swetgram.domain.UserId
import com.swetdot.swetgram.ui.chat.ChatScreen
import com.swetdot.swetgram.ui.chat.ChatViewModel
import com.swetdot.swetgram.ui.chat.chatSubtitle
import com.swetdot.swetgram.ui.chats.ArchivedChatsScreen
import com.swetdot.swetgram.ui.chats.ChatCommands
import com.swetdot.swetgram.ui.chats.ChatListScreen
import com.swetdot.swetgram.ui.chats.ChatListViewModel
import com.swetdot.swetgram.ui.chats.NewChatScreen
import com.swetdot.swetgram.ui.chats.NewChatViewModel
import com.swetdot.swetgram.ui.design.Motion
import com.swetdot.swetgram.ui.design.LocalOpenSwetgramBlack
import com.swetdot.swetgram.ui.design.SwetBottomNav
import com.swetdot.swetgram.ui.design.SwetEasing
import com.swetdot.swetgram.ui.design.SwetNavTab
import com.swetdot.swetgram.ui.design.motionDurationMillis
import com.swetdot.swetgram.ui.design.swetFloatingNavClearance
import com.swetdot.swetgram.ui.design.reduceMotion
import com.swetdot.swetgram.ui.design.swetTransitionTarget
import com.swetdot.swetgram.ui.discover.CommentComposerAuthor
import com.swetdot.swetgram.ui.discover.CommentsSheet
import com.swetdot.swetgram.ui.discover.ComposePostScreen
import com.swetdot.swetgram.ui.discover.ComposePostViewModel
import com.swetdot.swetgram.ui.discover.DiscoverScreen
import com.swetdot.swetgram.ui.discover.DiscoverViewModel
import com.swetdot.swetgram.ui.discover.DiscoverBrowseViewModel
import com.swetdot.swetgram.ui.discover.GroupDiscoverScreen
import com.swetdot.swetgram.ui.discover.PostDetailScreen
import com.swetdot.swetgram.ui.discover.PostDetailViewModel
import com.swetdot.swetgram.ui.discover.SavedPostsScreen
import com.swetdot.swetgram.ui.discover.SavedPostsViewModel
import com.swetdot.swetgram.ui.discover.ActivityScreen
import com.swetdot.swetgram.ui.discover.ActivityViewModel
import com.swetdot.swetgram.ui.discover.asPostDetailSource
import com.swetdot.swetgram.ui.groups.CreateGroupScreen
import com.swetdot.swetgram.ui.groups.CreateGroupViewModel
import com.swetdot.swetgram.ui.groups.GroupBansScreen
import com.swetdot.swetgram.ui.groups.GroupBansViewModel
import com.swetdot.swetgram.ui.groups.GroupInviteScreen
import com.swetdot.swetgram.ui.groups.GroupInviteViewModel
import com.swetdot.swetgram.ui.groups.GroupJoinRequestsScreen
import com.swetdot.swetgram.ui.groups.GroupJoinRequestsViewModel
import com.swetdot.swetgram.ui.groups.GroupMembersScreen
import com.swetdot.swetgram.ui.groups.GroupMembersViewModel
import com.swetdot.swetgram.ui.groups.GroupScreen
import com.swetdot.swetgram.ui.groups.GroupSettingsScreen
import com.swetdot.swetgram.ui.groups.GroupSettingsViewModel
import com.swetdot.swetgram.ui.groups.GroupViewModel
import com.swetdot.swetgram.ui.groups.GroupsScreen
import com.swetdot.swetgram.ui.groups.GroupSearchCommands
import com.swetdot.swetgram.ui.groups.GroupsViewModel
import com.swetdot.swetgram.ui.groups.JoinGroupScreen
import com.swetdot.swetgram.ui.groups.JoinGroupViewModel
import com.swetdot.swetgram.ui.links.ExternalLinkInbox
import com.swetdot.swetgram.ui.links.ExternalLink
import com.swetdot.swetgram.ui.links.ExternalLinkKind
import com.swetdot.swetgram.ui.links.LinkResolverScreen
import com.swetdot.swetgram.ui.links.LinkResolverViewModel
import com.swetdot.swetgram.ui.links.parseExternalLink
import com.swetdot.swetgram.ui.moderation.ModerationQueueScreen
import com.swetdot.swetgram.ui.moderation.ModerationQueueViewModel
import com.swetdot.swetgram.ui.moderation.ModerationReportScreen
import com.swetdot.swetgram.ui.moderation.ModerationReportViewModel
import com.swetdot.swetgram.ui.moderation.ReportRequest
import com.swetdot.swetgram.ui.moderation.ReportSheetHost
import com.swetdot.swetgram.ui.moderation.ReportViewModel
import com.swetdot.swetgram.ui.moderation.asModerationSource
import com.swetdot.swetgram.ui.profile.BlockedUsersScreen
import com.swetdot.swetgram.ui.profile.BlockedUsersViewModel
import com.swetdot.swetgram.ui.profile.EditProfileScreen
import com.swetdot.swetgram.ui.profile.EditProfileViewModel
import com.swetdot.swetgram.ui.profile.MyProfileViewModel
import com.swetdot.swetgram.ui.profile.NotificationSettingsScreen
import com.swetdot.swetgram.ui.profile.NotificationSettingsViewModel
import com.swetdot.swetgram.ui.profile.PrivacyScreen
import com.swetdot.swetgram.ui.profile.PrivacyViewModel
import com.swetdot.swetgram.ui.profile.ProfileScreen
import com.swetdot.swetgram.ui.profile.PublicProfileScreen
import com.swetdot.swetgram.ui.profile.PublicProfileViewModel
import com.swetdot.swetgram.ui.profile.SettingsScreen
import com.swetdot.swetgram.ui.profile.SettingsViewModel
import com.swetdot.swetgram.ui.premium.PremiumScreen
import com.swetdot.swetgram.ui.premium.PremiumViewModel
import com.swetdot.swetgram.ui.tasks.TasksScreen
import com.swetdot.swetgram.ui.tasks.TasksViewModel
import com.swetdot.swetgram.ui.shop.XpShopScreen
import com.swetdot.swetgram.ui.shop.XpShopViewModel
import com.swetdot.swetgram.ui.theme.SwetgramThemeTokens
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource
import swetgram.shared.generated.resources.Res
import swetgram.shared.generated.resources.chatlist_tab_chats
import swetgram.shared.generated.resources.chatlist_tab_discover
import swetgram.shared.generated.resources.chatlist_tab_picso
import swetgram.shared.generated.resources.chatlist_tab_tasks
import swetgram.shared.generated.resources.chatlist_tab_groups
import swetgram.shared.generated.resources.chatlist_tab_profile
import androidx.compose.runtime.rememberCoroutineScope
import kotlinx.coroutines.launch
import kotlinx.coroutines.flow.first
import androidx.compose.material3.Text
import swetgram.shared.generated.resources.picso_error_expired
import swetgram.shared.generated.resources.picso_error_load
import swetgram.shared.generated.resources.picso_retry
import com.swetdot.swetgram.data.moderation.ReportTarget
import com.swetdot.swetgram.ui.moderation.ReportedAccount
import com.swetdot.swetgram.ui.picso.PicsoScreen
import com.swetdot.swetgram.ui.picso.PicsoViewModel
import com.swetdot.swetgram.ui.picso.PicsoCaptureScreen
import com.swetdot.swetgram.ui.picso.PicsoCaptureViewModel
import com.swetdot.swetgram.protocol.dto.ResolvedLinkType
import kotlin.time.Clock

/**
 * Top-level structure.
 *
 * Five product areas share the root navigation: Chats, Discover, Tasks, Groups and Profile.
 * `openapi.yaml` describes their data contracts while this enum owns their UI order.
 */
/**
 * THE LABEL IS A `StringResource` AND NOT A `String`, WHICH IS THE WHOLE OF THE CHANGE HERE.
 *
 * These four words are the most visible copy in the app: they are on every screen, in every state,
 * and they were the last four English words a Russian phone could not get rid of. They were
 * `String`s in this constructor, which is a place no `stringResource` can be called from -- an enum
 * entry is initialised once, outside any composition, and `stringResource` is a `@Composable`.
 *
 * `StringResource` is an ORDINARY VALUE in commonMain; only the LOOKUP is composable. So the entry
 * names the message and the bottom bar resolves it where it draws, which is the same seam `UiText`
 * describes at length and the reason nothing here needed a `UiText` of its own: there is no rule to
 * test, only a constant per tab.
 *
 * `route` stays a `String` and must: it is a navigation key that the graph, the deep links and
 * `saveState`/`restoreState` all match on. A route that changed with the phone's language would
 * strand every saved back stack the first time somebody switched locales.
 */
enum class Tab(val route: String, val label: StringResource, val glyph: TabGlyphKind) {
    Chats("chats", Res.string.chatlist_tab_chats, TabGlyphKind.Chats),
    Picso("picso", Res.string.chatlist_tab_picso, TabGlyphKind.Picso),
    Tasks("tasks", Res.string.chatlist_tab_tasks, TabGlyphKind.Tasks),
    Groups("groups", Res.string.chatlist_tab_groups, TabGlyphKind.Groups),
    Profile("profile", Res.string.chatlist_tab_profile, TabGlyphKind.Profile),
}

/** The pattern, not a filled path -- `NavDestination.route` reports it with the argument in it. */
private const val CHAT_ROUTE = "chat/{chatId}"
private const val CHAT_ID_ARG = "chatId"

private fun chatRoute(chatId: ChatId): String = "chat/${chatId.value}"

/**
 * SPS §10.9's New Chat screen, and SPS §10.6's Archive.
 *
 * Both are pushed off the Chats tab rather than being tabs of their own: the archive is a
 * filtered view of the same inbox, and the New Chat screen is a one-shot flow that finishes by
 * replacing itself with the conversation it opened.
 */
private const val NEW_CHAT_ROUTE = "chats/new"
private const val ARCHIVED_ROUTE = "chats/archived"

/**
 * Pushed detail screens behind the Profile tab. None of them is a tab, so the bottom bar is
 * hidden on all of them for the same reason it is hidden on the conversation screen.
 */
private const val EDIT_PROFILE_ROUTE = "profile/edit"
private const val SETTINGS_ROUTE = "settings"
private const val PRIVACY_ROUTE = "settings/privacy"
private const val BLOCKED_USERS_ROUTE = "settings/blocked"
private const val NOTIFICATIONS_ROUTE = "settings/notifications"
private const val PREMIUM_ROUTE = "settings/swetgram-black"

/**
 * SPS §16.4's moderation panel: the report queue, and one report with its decision form.
 *
 * REACHED ONLY FROM SETTINGS, and only when `getMe` has actually answered `moderator` or `admin` --
 * `SettingsScreen` applies `canOpenModeration` itself, so a host that wired the entry
 * unconditionally still cannot show it to an ordinary account. There is no tab, no deep link and no
 * other entrance anywhere in this file.
 *
 * THE ROUTES ARE STILL REGISTERED FOR EVERYBODY, and that is not a hole. A route is a string in a
 * navigation graph, not a permission: both screens call `/admin` operations that answer
 * `403 admin_role_required` against `users.role`, and both render that as a terminal "This account
 * does not have moderator access." with no Try again. Making registration conditional would put a
 * security decision in a `when` over a role this client cannot verify, and would crash the app if a
 * role changed while a screen was on the back stack.
 *
 * `moderation/{reportId}` rather than a nested `moderation/reports/{reportId}`: there is one kind of
 * thing on this panel, and the two-segment form would only exist to look like a REST path. It cannot
 * collide with the queue -- `moderation` is a literal and `moderation/{reportId}` has a second
 * segment, so the matcher never has to choose between them.
 */
private const val MODERATION_ROUTE = "moderation"
private const val MODERATION_REPORT_ROUTE = "moderation/{reportId}"
private const val REPORT_ID_ARG = "reportId"

private fun moderationReportRoute(reportId: String): String = "moderation/$reportId"

/**
 * Someone else's profile, keyed by USERNAME -- the contract's `getUserByUsername` is the only
 * operation that reads a public profile, and a profile link resolves to a username too.
 *
 * Reached from the two screens that show another person: tapping a peer's avatar in the chat
 * list, and tapping the conversation header. The same route is what a profile-link deep link
 * will resolve to.
 */
private const val PUBLIC_PROFILE_ROUTE = "user/{username}"
private const val USERNAME_ARG = "username"

private fun publicProfileRoute(username: String): String = "user/$username"

/** Temporary destination while an immutable QR target or public username is resolved by the API. */
private const val LINK_RESOLVER_ROUTE = "link/{kind}/{value}"
private const val LINK_KIND_ARG = "kind"
private const val LINK_VALUE_ARG = "value"

private fun linkResolverRoute(kind: ExternalLinkKind, value: String): String =
    "link/${kind.name.lowercase()}/$value"

/**
 * SPS §11: the Discover composer, and one post with its comment thread.
 *
 * Both are pushed off the Discover tab, and the composer is reachable from the Chats tab as well --
 * SDS §11.8 gives the chat list a second, smaller floating action that writes a post. One route with
 * two entrances rather than two composers.
 *
 * SINGULAR `post/` for the detail route against the plural `discover/` prefix on the composer, which
 * is the same split `chat/{chatId}` under a `chats` tab and `group/{groupId}` under `groups` already
 * use. It also keeps the matcher out of an ambiguity: `discover/compose` and a hypothetical
 * `discover/{postId}` are the same shape, and which one a navigation resolved to would depend on the
 * library's tie-break rather than on anything written here.
 */
private const val COMPOSE_POST_ROUTE = "discover/compose"
private const val LINKED_COMPOSE_POST_ROUTE = "discover/compose-linked"
private const val SAVED_POSTS_ROUTE = "discover/saved"
private const val DISCOVER_ACTIVITY_ROUTE = "discover/activity"
private const val POST_DETAIL_ROUTE = "post/{postId}"
private const val POST_ID_ARG = "postId"

private fun postDetailRoute(postId: DiscoverPostId): String = "post/${postId.value}"

/** Picso 24h photo moments and personal memories archive. */
private const val PICSO_CAPTURE_ROUTE = "picso/capture"
private const val PICSO_DETAIL_ROUTE = "picso/view/{picsoId}"

/**
 * SPS §12: the create flow, one group, and its members. All three are pushed off the Groups tab.
 *
 * SINGULAR `group/` for the two detail routes, plural `groups/` only for the tab and the create
 * flow, which mirrors `chat/{chatId}` sitting under a `chats` tab. It also keeps the matcher out of
 * an ambiguity it does not need: `groups/new` and a hypothetical `groups/{groupId}` are the same
 * shape, and which one a navigation resolves to would depend on the library's tie-break rather than
 * on anything written here.
 *
 * The group's CHAT is deliberately not a route of its own. A group's conversation is a conversation
 * row of type `group` -- pass 1's schema decision -- so the Chat entry navigates to [CHAT_ROUTE],
 * the same destination a direct message opens, addressed by `Group.conversationId`.
 */
private const val CREATE_GROUP_ROUTE = "groups/new"
private const val GROUP_ROUTE = "group/{groupId}"
private const val GROUP_MEMBERS_ROUTE = "group/{groupId}/members"
private const val GROUP_INVITE_ROUTE = "group/{groupId}/invite"
private const val GROUP_JOIN_REQUESTS_ROUTE = "group/{groupId}/join-requests"
private const val GROUP_BANS_ROUTE = "group/{groupId}/bans"
private const val GROUP_SETTINGS_ROUTE = "group/{groupId}/settings"

/**
 * SPS §12.5's group Discover area, and its composer.
 *
 * THE SECOND OF THE THREE SECTIONS SPS §12.1 AND SDS §14.1 GIVE A GROUP -- Chat, Discover, Members
 * -- and the last of them to get a destination. Both sit under `group/{groupId}/`, beside Members
 * and the three moderation routes, because they are the same object seen a different way.
 *
 * NEITHER CAN COLLIDE with [GROUP_ROUTE] or [GROUP_MEMBERS_ROUTE]: three and four segments against
 * two and three, and the matcher counts segments before it looks at anything else. They cannot
 * collide with EACH OTHER for the same reason.
 *
 * The composer is a route rather than a flag on the feed's, so publishing to a group and publishing
 * to the world are the same screen behind the same view model, differing only in the
 * `DiscoverFeedId` each is constructed with. See [COMPOSE_POST_ROUTE], which is its global twin.
 */
private const val GROUP_DISCOVER_ROUTE = "group/{groupId}/discover"
private const val GROUP_COMPOSE_POST_ROUTE = "group/{groupId}/discover/compose"
private const val GROUP_ID_ARG = "groupId"

internal enum class NavigationMotionKind { Tab, Detail, Composer }

private val COMPOSER_ROUTES = setOf(
    COMPOSE_POST_ROUTE,
    LINKED_COMPOSE_POST_ROUTE,
    GROUP_COMPOSE_POST_ROUTE,
    CREATE_GROUP_ROUTE,
    PICSO_CAPTURE_ROUTE,
)

private val TAB_ROUTES = Tab.entries.mapTo(mutableSetOf()) { it.route }

/** Chooses motion from navigation hierarchy rather than applying one effect to every route. */
internal fun navigationMotionKind(initialRoute: String?, targetRoute: String?): NavigationMotionKind {
    if (targetRoute in TAB_ROUTES && (initialRoute == null || initialRoute in TAB_ROUTES)) {
        return NavigationMotionKind.Tab
    }
    if (initialRoute in COMPOSER_ROUTES || targetRoute in COMPOSER_ROUTES) {
        return NavigationMotionKind.Composer
    }
    return NavigationMotionKind.Detail
}

private fun groupRoute(groupId: GroupId): String = "group/${groupId.value}"

private fun groupMembersRoute(groupId: GroupId): String = "group/${groupId.value}/members"

private fun groupInviteRoute(groupId: GroupId): String = "group/${groupId.value}/invite"

private fun groupJoinRequestsRoute(groupId: GroupId): String = "group/${groupId.value}/join-requests"

private fun groupBansRoute(groupId: GroupId): String = "group/${groupId.value}/bans"

private fun groupSettingsRoute(groupId: GroupId): String = "group/${groupId.value}/settings"

private fun groupDiscoverRoute(groupId: GroupId): String = "group/${groupId.value}/discover"

private fun groupComposePostRoute(groupId: GroupId): String =
    "group/${groupId.value}/discover/compose"

/**
 * Where an invite link lands. `JoinGroupViewModel` names this route and the shape is its, not a
 * choice made here: `join/{invite_token}`, one path segment, passed through VERBATIM.
 *
 * NOT UNDER `group/`, and that is the whole point. Everything else in this file addresses a group by
 * its id, which the person following an invite does not have and — for a private group — is not
 * entitled to until they are let in. The token is the only thing they hold, which is exactly why the
 * contract puts `/join/{invite_token}` at the API root rather than under `/groups`.
 *
 * NOTHING NORMALISES THE TOKEN. It is a case-sensitive credential of at least 20 base64url
 * characters; lower-casing or trimming it turns a working link into a 404 that reads as revoked.
 */
private const val JOIN_GROUP_ROUTE = "join/{inviteToken}"
private const val INVITE_TOKEN_ARG = "inviteToken"

private fun joinGroupRoute(token: String): String = "join/$token"

/**
 * Whether this destination is drawn on the app's CANVAS -- `background.deep`, edge to edge -- or on
 * the ordinary `background`.
 *
 * PURE, AND INTERNAL SO IT CAN BE ASSERTED. It used to be a `when` with four route names in it and
 * one of them missing, which is exactly the shape of defect a list of names has: `Tab.Profile` was
 * left off, so three tabs floated their bottom bar over #000000 and the fourth floated it over
 * #0B0B0B. Nothing about that is visible in a screenshot of one tab, and it is the difference the
 * user reported as the bar "not being like the chats list".
 *
 * WRITTEN AS `Tab.entries` RATHER THAN AS FOUR NAMES, so a fifth tab cannot be added and forgotten.
 * That is the whole reason this is a function and not a `when`.
 *
 * [CHAT_ROUTE] is here for its own reason, unchanged and not a tab: DECISIONS.md §25. The
 * conversation mockup's first line is "canvas: pure black, edge to edge -- the header shares it",
 * and the screen cannot paint the strip behind the status bar because it does not own it.
 *
 * NULL USES THE CANVAS. The host has not resolved its initial tab on the first frame, and painting
 * the ordinary background there caused a visible #0B0B0B-to-black startup flash. The app starts on
 * a root tab, so the unresolved frame uses the same canvas as that destination.
 */
internal fun frameIsCanvas(route: String?): Boolean =
    route == null || route == CHAT_ROUTE || Tab.entries.any { it.route == route }

/** The bottom bar belongs only to root tabs; future detail routes are hidden by default. */
internal fun showsBottomNav(route: String?): Boolean = route == null || route in TAB_ROUTES

/**
 * The app frame: a navigation host with SDS §11.6's bottom bar under it.
 *
 * Built as a `Column` rather than a Material `Scaffold`, for the reason the conversation screen
 * needs and the chat list does not: INSETS. `Scaffold` hands its content a bottom padding, and
 * the composer already lifts itself over the keyboard and the gesture bar
 * (`imePadding` + `navigationBarsPadding`). Both together push the input up by the gesture bar
 * twice, and by the whole keyboard plus the tab bar when the keyboard opens -- a bug that shows
 * up only on a device, which is exactly the class of defect this frame has to avoid. Here the
 * top inset is applied once, at the top, and the bottom belongs to whichever component actually
 * sits at the bottom: the tab bar, or the composer.
 *
 * THE HORIZONTAL INSET IS APPLIED HERE TOO, and for the same reason the status bar is: it is one
 * rule for every screen, not a modifier each one has to remember. Nothing else in `ui/` insets
 * the sides, so in landscape -- or on a phone with a display cutout -- the chat rows' timestamps,
 * both floating actions, the top bar's trailing actions and Discover's Refresh control were all
 * drawn under the gesture strip or the cutout. It goes on the `NavHost` rather than on this
 * `Column` deliberately: `windowInsetsPadding` CONSUMES what it applies, so on the `Column` it
 * would also inset [SwetBottomNav]'s `Surface` and stop the tab bar's colour short of the edge,
 * leaving a bare band of window background beside the tabs. The bottom bar therefore takes the
 * same inset itself, inside its own surface, exactly as it already takes `navigationBarsPadding`.
 *
 * The `background` under the status-bar inset is part of the same fix: with the sides no longer
 * painted by the app bar's `Surface`, an unpainted strip would otherwise show beside it.
 *
 * The bottom bar is hidden on the conversation screen. It is a pushed detail screen, not a tab,
 * and 64dp of tab bar under a chat composer is both wrong for the product and the thing that
 * made the bottom inset ambiguous.
 */
@Composable
fun SwetgramApp(
    container: AppContainer,
    navController: NavHostController = rememberNavController(),
) {
    val me = UserId(container.session.currentUserId.orEmpty())
    val backStack by navController.currentBackStackEntryAsState()
    val current = backStack?.destination?.route
    val pendingExternalLink by ExternalLinkInbox.pending.collectAsStateWithLifecycle()

    // The inbox retains the URL while the auth gate is visible. Once a verified session reaches
    // this host, invite links open directly and profile/group links pass through the resolver so
    // immutable QR ids and changeable public usernames both reach the same screen.
    LaunchedEffect(pendingExternalLink) {
        val raw = pendingExternalLink ?: return@LaunchedEffect
        val link = parseExternalLink(raw)
        if (link != null) {
            when (link.kind) {
                ExternalLinkKind.JOIN -> navController.navigate(joinGroupRoute(link.value))
                ExternalLinkKind.USER,
                ExternalLinkKind.GROUP,
                -> navController.navigate(linkResolverRoute(link.kind, link.value))
            }
        }
        ExternalLinkInbox.consume(raw)
    }

    /**
     * Pin, archive, delete and people search (SPS §10.4-10.7).
     *
     * Built ONCE here rather than inside each `viewModel { }` factory, so the chat list, the
     * archive and the New Chat screen all issue their requests through the same object. It holds
     * no state, but three copies would be three things to move when it lands in `data/` where
     * its own TODO says it belongs.
     */
    val chatCommands = remember(container) { ChatCommands(container.api) }

    /**
     * SPS §16.3's report flow. ONE instance for the whole app, and the placement is the point.
     *
     * It is created HERE, above the `NavHost`, so its `viewModelScope` belongs to the host rather
     * than to any destination. A report is raised from a message bubble, a feed card, a comment, a
     * profile or a group screen, and the sheet is a `Dialog` drawn over whichever of those the user
     * was on -- so if this lived inside a destination's scope, navigating away (or the report itself
     * causing a pop) would cancel the POST mid-flight and leave somebody unsure whether a report
     * they can never withdraw was filed. `ReportFlow.kt`'s header states the same rule.
     *
     * It is also why there is no `key` and no `remember(container)` around it: five surfaces raise
     * into one flow, and a second instance would be a second sheet that could open behind the first.
     *
     * The blocker is SPS §16.2's block, offered on the receipt beside §16.3's report -- the two acts
     * the folder keeps in adjacent subsections and never relates. `BlockRepository::block` is the
     * same call the public profile's own Block button makes; nothing here is a second implementation
     * of it.
     */
    val reportViewModel = viewModel {
        ReportViewModel(
            reports = container.reports,
            blocks = container.blocks::block,
        )
    }

    /**
     * What every reportable surface is handed, or null when nothing can send a report.
     *
     * Hoisted so the five call sites cannot disagree, and expressed as a nullable value rather than
     * as `reportViewModel::open` directly because NULL IS THE FEATURE: each surface hides its Report
     * control entirely when this is null, instead of drawing one that quietly does nothing. It is
     * non-null on every build that has `AppContainer.reports`, which is every build -- the branch
     * exists so that the screens' own contract stays honest and testable, not because this app turns
     * reporting off.
     */
    val onReport: ((ReportRequest) -> Unit)? =
        if (reportViewModel.canReport) reportViewModel::open else null

    /**
     * The reader's own disc on the comment composer, and the lambda that asks for it.
     *
     * Hoisted to the frame so ONE request serves both Discover feeds, and deferred so a session that
     * never opens a comment thread never makes it at all. See [rememberComposerAuthor].
     */
    val (composerAuthor, requestComposerAuthor) = rememberComposerAuthor(container)

    // Read ONCE, here, because `reduceMotion()` is @Composable and the transition lambdas below
    // are not composable scopes. `motionDurationMillis` returns 0 under reduced motion, which is
    // how §22.6 reaches the navigation graph -- see the transitions on the NavHost.
    val reducedMotion = reduceMotion()
    val transitionMillis = motionDurationMillis(Motion.normal, reducedMotion)
    val fastTransitionMillis = motionDurationMillis(Motion.fast, reducedMotion)

    // Null on the very first frame, before the host has resolved its start destination. Treated
    // as a tab so the bar does not flash in after the first composition.
    val showBottomNav = showsBottomNav(current)
    val currentTabIndex = Tab.entries.indexOfFirst { it.route == current }
    var lastSelectedTabIndex by rememberSaveable { mutableStateOf(0) }
    LaunchedEffect(currentTabIndex) {
        if (currentTabIndex >= 0) lastSelectedTabIndex = currentTabIndex
    }
    val selectedIndex = currentTabIndex.takeIf { it >= 0 } ?: lastSelectedTabIndex
    val bottomNavVisibility = remember { MutableTransitionState(showBottomNav) }
    bottomNavVisibility.targetState = showBottomNav

    /*
     * THE FRAME'S FILL FOLLOWS THE DESTINATION, and the conversation is the one destination that
     * wants a different one.
     *
     * The mockup's first line is "canvas: pure black, edge to edge -- the header shares it".
     * `ChatScreen` paints `chat.canvas` on its own root, its header and its composer, but this frame
     * paints the whole WINDOW and then insets every screen below the status bar, so the strip behind
     * the status bar (and, in landscape, the strips beside a cutout) kept the ordinary #0B0B0B
     * app background while the header a pixel below it was #000000. The delta is 11/255 and easy to
     * miss, which is exactly why it needed saying rather than living on as a comment claiming a
     * result the composition did not produce.
     *
     * The BACKGROUND changes and the `statusBarsPadding` below does not: content still sits clear of
     * the status bar on every screen, including this one. What changes is only what is painted
     * underneath it. Every other destination is unaffected.
     */
    /*
     * THE CHATS TAB JOINS THE CONVERSATION ON THE CANVAS. DECISIONS.md §26.
     *
     * The chat-list mockup's first line is the same as the conversation mockup's: "pure black, edge
     * to edge". That takes two files for the same reason §25 records -- the screen paints its own
     * root, and this frame paints the WINDOW, including the strip behind the status bar and the
     * strips beside a cutout. Without this line the inbox's #000000 header sat a pixel under a
     * #0B0B0B status strip, which is 1.067:1 and is exactly the seam §25 was written about.
     */
    /*
     * ALL ROOT TABS JOIN THEM, which is the whole of this change, and Profile is the one the user
     * reported.
     *
     * Chats, Discover and Groups were re-skinned to the same mockup and all three paint
     * `background.deep` on their own root -- and a screen paints only its own bounds, so on each a
     * #000000 header sat a pixel under a #0B0B0B status strip. 1.067:1, invisible in a screenshot and
     * obvious on glass, which is the seam §25 and §26 were written about.
     *
     * PROFILE WAS LEFT OFF THAT LIST and the consequence was not at the top of the screen but at the
     * bottom of it. The floating bar's fill is `card` and its edge is `border`; on three tabs those
     * sat on #000000 and on the fourth on #0B0B0B, so the same component read as a different
     * component depending on which tab you were looking at. That is the "not round and normal like
     * the chats list" the report names, and it is a colour rather than a shape.
     *
     * `colors.backgroundDeep` RATHER THAN `chat.canvas`, which is the same value by construction --
     * `chat.canvas = colors.backgroundDeep` in `SwetgramColors.kt`. Five destinations, only one of
     * which is a conversation, should not name their fill through the conversation's token.
     *
     * The membership test itself is [frameIsCanvas], which is `Tab.entries` rather than a list of
     * names for the reason its own KDoc gives.
     */
    val frameBackground = if (frameIsCanvas(current)) {
        SwetgramThemeTokens.colors.backgroundDeep
    } else {
        SwetgramThemeTokens.colors.background
    }

    /*
     * NOTHING IS PADDED HERE ANY MORE, AND THAT IS THE CHANGE.
     *
     * `SwetBottomNav` used to be a full-width bar attached to the bottom edge and a plain sibling in
     * this `Column`: it took its own 64dp out of the layout and nothing underneath had to know it
     * existed. The mockup makes it FLOAT, and a floating bar is drawn over whatever is behind it --
     * so somebody has to keep the last row of every list out from under it.
     *
     * There were two answers to "who", and having two was the defect. The inbox and the Groups list
     * reserved `swetFloatingNavClearance()` in their OWN `contentPadding`, so their canvas ran to the
     * bottom edge and their rows scrolled under the bar. Discover and Profile were padded HERE
     * instead, by a `barOverlapsContent` flag naming the other two -- so on those two tabs the screen
     * stopped short and the bar floated over a bare strip of frame colour with nothing behind it. One
     * bar, two arrangements, and the difference read as the bar itself being wrong.
     *
     * SO THE HOST PADS NOBODY AND EVERY SCROLLABLE RESERVES ITS OWN, which is what the two right ones
     * already did:
     *
     *  - `ChatListScreen` and `GroupsScreen`: `contentPadding` on their `LazyColumn`. UNTOUCHED --
     *    they are the reference, and a change to either would be a change to the thing being matched.
     *  - `DiscoverScreen`: `contentPadding` too, but its number is a PAIR, because the tab also
     *    carries the app's last remaining door to the post composer as a floating disc. The feed
     *    reserves the disc stack PLUS the bar and the disc lifts by the bar, and both numbers come
     *    out of one `fabStackOverFloatingNav` call so neither can move without the other.
     *  - `ProfileScreen`: not a lazy list, so the same clearance goes on its scrolled content. Its
     *    own file says where and why.
     *
     * THE DETAIL ROUTES ARE UNAFFECTED, and were before: the old expression was already 0dp whenever
     * `showBottomNav` was false. Nothing pushed a conversation's composer up, and nothing does now.
     */

    var linkedComposeSeed by remember { mutableStateOf<Pair<DiscoverPost, DiscoverPostType>?>(null) }

    Column(
        modifier = Modifier
            .fillMaxSize()
            // Painted BEFORE the inset, so the whole window is covered -- including the strip
            // beside the app bar that the horizontal inset below now keeps content out of.
            .background(frameBackground)
            // The activity runs edge to edge, so the status bar / iOS safe area is inset here
            // once, for every screen. SwetTopAppBar deliberately applies none of its own.
            .statusBarsPadding(),
    ) {
        Box(Modifier.weight(1f)) {
            CompositionLocalProvider(
                LocalOpenSwetgramBlack provides {
                    navController.navigate(PREMIUM_ROUTE) { launchSingleTop = true }
                },
            ) {
                NavHost(
                navController = navController,
                startDestination = Tab.Chats.route,
                modifier = Modifier
                    .fillMaxSize()
                    // The SIDES, once, for every screen -- the companion to `statusBarsPadding`
                    // above. `safeDrawing` rather than `systemBars` so a display cutout counts as
                    // well as the gesture strip. On the NavHost and not on the Column: this
                    // modifier consumes the inset it applies, and the bottom bar wants to sit
                    // clear of the side gesture strip on its own terms (see `SwetBottomNav`).
                    .windowInsetsPadding(WindowInsets.safeDrawing.only(WindowInsetsSides.Horizontal)),
                // Stated explicitly, because the alternative is not "no animation": the navigation
                // library's own defaults are a 700ms fade on Android and a 200ms slide on iOS.
                // That is three times the SDS §19.2 duration on one platform and a different
                // gesture on the other, from identical code -- exactly what §23.1 forbids.
                //
                // AND THEY OBEY REDUCED MOTION, which they did not: `tween` was built by hand here,
                // so §22.6 ("disable non-essential transitions") was enforced everywhere in the app
                // EXCEPT the one animation that runs on every screen change. `swetTween` is where
                // that rule lives, and it is @Composable -- it cannot be called inside these lambdas
                // -- so the preference is read once above and fed to `motionDurationMillis`, which
                // returns 0 under reduced motion. The DURATION is unchanged otherwise, and the curves
                // are now §19.3's named pair rather than Material's near-equivalents.
                enterTransition = {
                    when (navigationMotionKind(initialState.destination.route, targetState.destination.route)) {
                        NavigationMotionKind.Tab ->
                            fadeIn(tween(fastTransitionMillis, easing = SwetEasing.enter))
                        NavigationMotionKind.Detail ->
                            fadeIn(tween(transitionMillis, easing = SwetEasing.enter)) +
                                slideInHorizontally(
                                    tween(transitionMillis, easing = SwetEasing.enter),
                                    initialOffsetX = { it / 12 },
                                )
                        NavigationMotionKind.Composer ->
                            fadeIn(tween(transitionMillis, easing = SwetEasing.enter)) +
                                slideInVertically(
                                    tween(transitionMillis, easing = SwetEasing.enter),
                                    initialOffsetY = { it / 10 },
                                )
                    }
                },
                exitTransition = {
                    when (navigationMotionKind(initialState.destination.route, targetState.destination.route)) {
                        NavigationMotionKind.Tab ->
                            fadeOut(tween(fastTransitionMillis, easing = SwetEasing.exit))
                        NavigationMotionKind.Detail ->
                            fadeOut(tween(transitionMillis, easing = SwetEasing.exit)) +
                                slideOutHorizontally(
                                    tween(transitionMillis, easing = SwetEasing.exit),
                                    targetOffsetX = { -it / 24 },
                                )
                        NavigationMotionKind.Composer ->
                            fadeOut(tween(transitionMillis, easing = SwetEasing.exit)) +
                                slideOutVertically(
                                    tween(transitionMillis, easing = SwetEasing.exit),
                                    targetOffsetY = { -it / 24 },
                                )
                    }
                },
                popEnterTransition = {
                    when (navigationMotionKind(initialState.destination.route, targetState.destination.route)) {
                        NavigationMotionKind.Tab ->
                            fadeIn(tween(fastTransitionMillis, easing = SwetEasing.enter))
                        NavigationMotionKind.Detail ->
                            fadeIn(tween(transitionMillis, easing = SwetEasing.enter)) +
                                slideInHorizontally(
                                    tween(transitionMillis, easing = SwetEasing.enter),
                                    initialOffsetX = { -it / 24 },
                                )
                        NavigationMotionKind.Composer ->
                            fadeIn(tween(transitionMillis, easing = SwetEasing.enter)) +
                                slideInVertically(
                                    tween(transitionMillis, easing = SwetEasing.enter),
                                    initialOffsetY = { -it / 24 },
                                )
                    }
                },
                popExitTransition = {
                    when (navigationMotionKind(initialState.destination.route, targetState.destination.route)) {
                        NavigationMotionKind.Tab ->
                            fadeOut(tween(fastTransitionMillis, easing = SwetEasing.exit))
                        NavigationMotionKind.Detail ->
                            fadeOut(tween(transitionMillis, easing = SwetEasing.exit)) +
                                slideOutHorizontally(
                                    tween(transitionMillis, easing = SwetEasing.exit),
                                    targetOffsetX = { it / 12 },
                                )
                        NavigationMotionKind.Composer ->
                            fadeOut(tween(transitionMillis, easing = SwetEasing.exit)) +
                                slideOutVertically(
                                    tween(transitionMillis, easing = SwetEasing.exit),
                                    targetOffsetY = { it / 10 },
                                )
                    }
                },
                ) {
                composable(Tab.Chats.route) {
                    val viewModel = viewModel {
                        ChatListViewModel(container.chats, container.realtime, chatCommands, me)
                    }

                    // Re-read the inbox every time this screen comes BACK into view.
                    //
                    // Marking a conversation read is a per-member write that the server deliberately
                    // does not announce on the conversation channel -- telling the other party when
                    // you read them is a presence disclosure of its own -- so nothing pushes the
                    // cleared unread count to this screen. Without this the badge a user just read
                    // away stays on their home screen until some unrelated event arrives.
                    //
                    // Gated on `loadedOnce` so the FIRST entry does not fire a second read on top of
                    // the one the view model's own init just started.
                    //
                    // `refreshQuietly`, NOT `refresh`, AND THAT IS THE USER-VISIBLE HALF OF IT. This
                    // block runs on every return to the tab -- the destination leaves composition
                    // when another tab is selected and re-enters when this one is -- and `refresh`
                    // raises `ChatListViewModel.refreshing`, which `ChatListScreen` hands straight to
                    // `PullToRefreshBox`. So opening the Chats tab dropped a spinner over an inbox
                    // that already had every row on it and was about to come back identical: the
                    // "always reload" in the report. The read itself is not the defect and is not
                    // removed -- the cached rows are on screen the whole time it runs.
                    LaunchedEffect(Unit) {
                        if (viewModel.loadedOnce.value) viewModel.refreshQuietly()
                    }

                    val chats by viewModel.chats.collectAsStateWithLifecycle()
                    val archived by viewModel.archived.collectAsStateWithLifecycle()
                    val error by viewModel.error.collectAsStateWithLifecycle()
                    val notice by viewModel.notice.collectAsStateWithLifecycle()
                    val loadedOnce by viewModel.loadedOnce.collectAsStateWithLifecycle()
                    val query by viewModel.query.collectAsStateWithLifecycle()
                    val people by viewModel.people.collectAsStateWithLifecycle()
                    val searching by viewModel.searching.collectAsStateWithLifecycle()
                    val searchSettled by viewModel.searchSettled.collectAsStateWithLifecycle()
                    val searchError by viewModel.searchError.collectAsStateWithLifecycle()
                    val typingChatIds by viewModel.typingChatIds.collectAsStateWithLifecycle()
                    val refreshing by viewModel.refreshing.collectAsStateWithLifecycle()
                    val muteDeadlines by viewModel.muteDeadlines.collectAsStateWithLifecycle()
                    ChatListScreen(
                        chats = chats,
                        me = me,
                        onOpenChat = { chatId ->
                            navController.navigate(chatRoute(chatId)) { launchSingleTop = true }
                        },
                        // SPS §10.4: chats, users and groups. Chats are filtered by the screen from
                        // the list it already holds; people come from `globalSearch`.
                        query = query,
                        onQueryChange = viewModel::onQueryChange,
                        people = people,
                        searching = searching,
                        searchSettled = searchSettled,
                        // A people-search that did not RUN must not be reported as one that found
                        // nobody. Without these two lines `searchError` is collected nowhere and
                        // `retrySearch` has no caller, so the screen falls back to its defaults and
                        // silently renders SDS §17.2's "No results found." over a failed lookup.
                        searchError = searchError,
                        onRetrySearch = viewModel::retrySearch,
                        // SPS §10.6. The screen hides the Archived entry itself when this is empty.
                        archived = archived,
                        onOpenArchive = { navController.navigate(ARCHIVED_ROUTE) },
                        error = error,
                        // A failed refresh is retryable, so the banner gets an action rather than
                        // leaving the user to guess that pulling the app around might help.
                        onRetry = viewModel::refresh,
                        // The pin limit and any failed row action, reported apart from the list's
                        // own state so a rejected pin does not make the screen look broken.
                        notice = notice,
                        onDismissNotice = viewModel::dismissNotice,
                        onOpenProfile = { username ->
                            navController.navigate(publicProfileRoute(username)) { launchSingleTop = true }
                        },
                        // SPS §10.9's New Chat flow. It is the HEADER's compose glyph now rather than
                        // §10.8's large floating action, and the empty state's button as before.
                        //
                        // `onNewPost` IS GONE FROM THIS CALL, not defaulted away: the mockup removes the
                        // second floating action and the Chats tab has nowhere left to put it, so the
                        // parameter went with it (DECISIONS.md §26). Keeping a lambda nothing can invoke
                        // is the dead-affordance this file argues against everywhere else. The composer
                        // is unaffected -- `COMPOSE_POST_ROUTE` is still reached from the Discover tab's
                        // floating action and from its empty state's button.
                        onNewChat = { navController.navigate(NEW_CHAT_ROUTE) { launchSingleTop = true } },
                        onSetPinned = viewModel::setPinned,
                        onSetArchived = viewModel::setArchived,
                        onDeleteChat = viewModel::deleteChat,
                        // SPS §15.3's "mute a specific chat". The row already drew SDS §12.1's bell for
                        // a state nothing in the app could set; these two are what set it. The deadline
                        // map is a session overlay, not cache -- `ChatRepository.muteDeadlines`.
                        onSetMuted = viewModel::setMuted,
                        muteDeadlines = muteDeadlines,
                        // SDS §12.1's row state, on the screen where it is seen most.
                        typingChatIds = typingChatIds,
                        // The only manual reload gesture in the app. Everything else that refreshes
                        // does so on a signal the user cannot see, which left a list that looked
                        // wrong with nothing to try.
                        onRefresh = viewModel::refresh,
                        refreshing = refreshing,
                        loadedOnce = loadedOnce,
                    )
                }

                // SPS §10.9. A one-shot flow: search, pick somebody, and the conversation replaces
                // this screen on the back stack so Back from the chat returns to the list.
                composable(NEW_CHAT_ROUTE) {
                    val viewModel = viewModel { NewChatViewModel(container.chats, chatCommands) }
                    val state by viewModel.state.collectAsStateWithLifecycle()

                    LaunchedEffect(state.openChatId) {
                        val opened = state.openChatId ?: return@LaunchedEffect
                        // Consumed BEFORE navigating: the flag is a one-shot signal, and leaving it
                        // set would push the same conversation again on the next recomposition.
                        viewModel.consumeOpened()
                        navController.navigate(chatRoute(opened)) {
                            popUpTo(NEW_CHAT_ROUTE) { inclusive = true }
                        }
                    }

                    NewChatScreen(
                        state = state,
                        onQueryChange = viewModel::onQueryChange,
                        onSelect = viewModel::open,
                        onBack = { navController.popBackStack() },
                        // The refused OPEN. Dismissible, and only that.
                        onDismissError = viewModel::dismissError,
                        // The failed SEARCH. Without this the screen's only error banner carried a
                        // dismiss X and no way to try again -- on the one route into a new
                        // conversation, for the failure a user is most likely to be able to fix.
                        onRetrySearch = viewModel::retrySearch,
                    )
                }

                composable(NOTIFICATIONS_ROUTE) {
                    val viewModel = viewModel { NotificationSettingsViewModel(container.notificationSettings) }
                    val state by viewModel.state.collectAsStateWithLifecycle()
                    NotificationSettingsScreen(
                        state = state,
                        onChange = viewModel::update,
                        onBack = { navController.popBackStack() },
                        onRetry = viewModel::refresh,
                        onDismissError = viewModel::dismissError,
                    )
                }

                composable(PREMIUM_ROUTE) {
                    val viewModel = viewModel { PremiumViewModel(container.premium) }
                    val state by viewModel.state.collectAsStateWithLifecycle()
                    val billing = container.premiumBilling
                    val billingState = if (billing != null) {
                        val observed by billing.state.collectAsStateWithLifecycle()
                        observed
                    } else {
                        null
                    }
                    LaunchedEffect(billingState?.verifiedRevision) {
                        if ((billingState?.verifiedRevision ?: 0) > 0) viewModel.refresh()
                    }
                    PremiumScreen(
                        state = state,
                        onBack = { navController.popBackStack() },
                        onRetry = viewModel::refresh,
                        onDismissError = viewModel::dismissError,
                        onStartPurchase = billing?.let { it::startPurchase },
                        onRestorePurchases = billing?.let { it::restorePurchases },
                        monthlyPrice = billingState?.offers
                            ?.firstOrNull { it.basePlanId == "monthly" }
                            ?.formattedRecurringPrice,
                        yearlyPrice = billingState?.offers
                            ?.firstOrNull { it.basePlanId == "yearly" }
                            ?.formattedRecurringPrice,
                        billingReady = billingState?.let { current ->
                            current.connected && current.offers.isNotEmpty()
                        } == true,
                        billingProcessing = billingState?.processing == true,
                        billingMessage = billingState?.message,
                        onBadgeVisibleChange = viewModel::setBadgeVisible,
                    )
                }

                // SPS §10.6: "archived chats can be restored". Its own view model instance, because
                // it is its own back-stack entry -- it observes the same cache, so restoring a chat
                // here updates the inbox underneath without either screen telling the other.
                composable(ARCHIVED_ROUTE) {
                    val viewModel = viewModel {
                        ChatListViewModel(container.chats, container.realtime, chatCommands)
                    }
                    val archived by viewModel.archived.collectAsStateWithLifecycle()
                    val error by viewModel.error.collectAsStateWithLifecycle()
                    val notice by viewModel.notice.collectAsStateWithLifecycle()
                    val loadedOnce by viewModel.loadedOnce.collectAsStateWithLifecycle()
                    val muteDeadlines by viewModel.muteDeadlines.collectAsStateWithLifecycle()
                    ArchivedChatsScreen(
                        chats = archived,
                        me = me,
                        onOpenChat = { chatId ->
                            navController.navigate(chatRoute(chatId)) { launchSingleTop = true }
                        },
                        onBack = { navController.popBackStack() },
                        error = error,
                        onRetry = viewModel::refresh,
                        notice = notice,
                        onDismissNotice = viewModel::dismissNotice,
                        onOpenProfile = { username ->
                            navController.navigate(publicProfileRoute(username)) { launchSingleTop = true }
                        },
                        onSetPinned = viewModel::setPinned,
                        onSetArchived = viewModel::setArchived,
                        onDeleteChat = viewModel::deleteChat,
                        // The archive carries the same row actions as the inbox, mute included: a
                        // conversation does not stop being mutable because it was filed away.
                        onSetMuted = viewModel::setMuted,
                        muteDeadlines = muteDeadlines,
                        loadedOnce = loadedOnce,
                    )
                }
                composable(CHAT_ROUTE) { entry ->
                    val chatId = ChatId(entry.arguments?.read { getStringOrNull(CHAT_ID_ARG) }.orEmpty())
                    val viewModel = viewModel(key = chatId.value) {
                        ChatViewModel(
                            chatId,
                            me,
                            container.messages,
                            container.realtime,
                            // A lambda, not `container.imagePicker` itself. The view model survives
                            // the Activity, and the picker does not: it is rebuilt in `onCreate` and
                            // reinstalled here, so it has to be read on the tap. Answers null on a
                            // platform with no chooser wired, and the composer then draws no attach
                            // button rather than one that opens nothing.
                            images = { container.imagePicker },
                            uploads = container.uploads,
                            voiceRecorders = { container.voiceRecorder },
                            voicePlayer = container.voicePlayer,
                            squadStreaks = container.squadStreaks,
                        )
                    }
                    val messages by viewModel.messages.collectAsStateWithLifecycle()
                    val chat by viewModel.chat.collectAsStateWithLifecycle()
                    val chatError by viewModel.error.collectAsStateWithLifecycle()
                    val squadStreak by viewModel.squadStreak.collectAsStateWithLifecycle()
                    val nudgeInProgress by viewModel.nudgeInProgress.collectAsStateWithLifecycle()
                    val startStreakInProgress by viewModel.startStreakInProgress.collectAsStateWithLifecycle()
                    val typingNames by viewModel.typingNames.collectAsStateWithLifecycle()
                    val uploading by viewModel.attachmentInFlight.collectAsStateWithLifecycle()
                    val chatLoadedOnce by viewModel.loadedOnce.collectAsStateWithLifecycle()
                    val pinned by viewModel.pinned.collectAsStateWithLifecycle()
                    val pinNotice by viewModel.pinNotice.collectAsStateWithLifecycle()
                    val sendNotice by viewModel.sendNotice.collectAsStateWithLifecycle()
                    val chatRefreshing by viewModel.refreshing.collectAsStateWithLifecycle()
                    val composerContext by viewModel.composerContext.collectAsStateWithLifecycle()
                    val voiceComposer by viewModel.voiceComposer.collectAsStateWithLifecycle()
                    val voicePlayback by viewModel.voicePlayback.collectAsStateWithLifecycle()
                    val forwardTargets by remember(container.chats) {
                        container.chats.observeChats(archived = false)
                    }.collectAsStateWithLifecycle(initialValue = emptyList())
                    // Read once per visit to this conversation. It only ever decides "today or
                    // yesterday or earlier" in the last-seen line, and reading the clock on every
                    // recomposition would make the header recompose on every frame of the timeline.
                    val now = remember { Clock.System.now() }

                    // Marking the conversation read is deliberately NOT here any more. Deciding when a
                    // conversation has been read is a judgement about what the reader has actually
                    // seen, and a routing table has no way to make it -- this one marked an entire
                    // unread run read the instant the route was entered. It now belongs to
                    // `ChatViewModel.observeReading`, which states the rule and owns the timing.
                    ChatScreen(
                        title = chat?.displayTitle(me) ?: "",
                        // SDS §12.3: "Online / last seen summary". For a group, §10.12's member
                        // count. `chatSubtitle` returns null when there is nothing TRUE to say, and
                        // the bar then draws a single title line rather than an empty second row.
                        subtitle = chatSubtitle(chat, me, now),
                        // The green dot on the header avatar. A boolean rather than a re-reading of
                        // the sentence above it -- see `ChatScreen.isOnline`.
                        isOnline = chat?.peer(me)?.isOnline == true,
                        // The same fallback the chat list applies: a group has its own picture, a
                        // direct chat borrows the other participant's.
                        avatarUrl = chat?.let { it.avatarUrl ?: it.peer(me)?.avatarUrl },
                        peerHasBlackBadge = chat?.peer(me)?.hasBlackBadge == true,
                        members = chat?.members ?: emptyList(),
                        messagesNewestFirst = messages,
                        me = me,
                        onSend = viewModel::send,
                        onBack = { navController.popBackStack() },
                        error = chatError,
                        onRetry = viewModel::refresh,
                        // Null for a group: there is no single person behind the header, so it stays
                        // inert rather than guessing which member to open.
                        peerUsername = chat?.peer(me)?.username,
                        onOpenProfile = { username ->
                            navController.navigate(publicProfileRoute(username)) { launchSingleTop = true }
                        },
                        onReact = viewModel::react,
                        typingNames = typingNames,
                        onOpenPicso = { id -> navController.navigate("picso/view/$id") { launchSingleTop = true } },
                        onDraftChanged = viewModel::onDraftChanged,
                        onAttachImage = viewModel::attachImage.takeIf { viewModel.canAttachImages },
                        attachmentInFlight = uploading,
                        voiceComposer = voiceComposer,
                        voicePlayback = voicePlayback,
                        onVoiceStart = viewModel::startVoiceRecording.takeIf { viewModel.canRecordVoice },
                        onVoiceRelease = viewModel::releaseVoiceRecording,
                        onVoiceLock = viewModel::lockVoiceRecording,
                        onVoiceCancel = viewModel::cancelVoiceRecording,
                        onVoicePauseResume = viewModel::toggleVoicePause,
                        onVoiceSend = viewModel::finishVoiceRecording,
                        onVoicePlaybackToggle = viewModel::toggleVoicePlayback,
                        onVoicePlaybackSeek = viewModel::seekVoicePlayback,
                        onVoicePlaybackSpeed = viewModel::cycleVoicePlaybackSpeed,
                        // SPS §10.13 / SDS §12.5 put Pin on the message long-press menu. The contract
                        // gives `listPinnedMessages` its own capped endpoint, so a pin needs a reader:
                        // the strip under the header and the full sheet behind it. Cap is five PER
                        // CONVERSATION (`maxItems: 5`), which is a different five from the five pinned
                        // conversations even though both answer `pin_limit_reached` -- hence the
                        // client-side notice rather than the server's sentence.
                        pinnedMessages = pinned,
                        onSetPinned = viewModel::setPinned,
                        composerContext = composerContext,
                        onReply = viewModel::setReplyingTo,
                        onEdit = viewModel::setEditingMessage,
                        onSaveEdit = viewModel::editMessage,
                        pinNotice = pinNotice,
                        onDismissPinNotice = viewModel::dismissPinNotice,
                        // SDS §12.5's Report, the second entry this build can put in the long-press
                        // menu. The screen decides WHERE it appears -- §12.5's "not sent by the current
                        // user" rule and the `danger` separation are both its -- and builds the whole
                        // `ReportRequest`, because it is the only thing here that knows both the message
                        // and who sent it.
                        onReport = onReport,
                        // SPS §19.5 and STA §4.8, both one line and both unmet before this: a failed
                        // message has to stay visible WITH A RETRY ACTION. The outbox row is keyed by
                        // `client_id`, which is the only identity an unsent message has.
                        onRetryMessage = viewModel::retryMessage,
                        onDiscardMessage = viewModel::discardMessage,
                        // SDS §12.5 / SPS §10.13's Delete, which had no client implementation at all
                        // -- the only `deleteMessage` on this client was the ADMIN endpoint. The
                        // boolean is the contract's required `scope`.
                        onDeleteMessage = viewModel::deleteMessage,
                        forwardTargets = forwardTargets,
                        onForwardMessages = viewModel::forwardMessages,
                        // Why the last send failed, in a sentence. The Result used to be discarded.
                        sendNotice = sendNotice,
                        onDismissSendNotice = viewModel::dismissSendNotice,
                        // The recovery path this screen was the only list without. The screen applies
                        // it to its EMPTY states only -- `PullToRefreshBox` fires on the unconsumed
                        // downward drag, which in a `reverseLayout` timeline is the top of history
                        // rather than the newest message. See ChatScreen and DECISIONS §22.
                        onRefresh = viewModel::refresh,
                        refreshing = chatRefreshing,
                        // Scroll-back. Cache first, and a request only when the cache runs out --
                        // see `ChatViewModel.loadOlder` and DECISIONS §22.
                        onLoadOlder = viewModel::loadOlder,
                        // So the screen does not open by announcing that a conversation with a
                        // thousand messages in it is empty. See `ChatViewModel.loadedOnce`.
                        loadedOnce = chatLoadedOnce,
                        squadStreak = squadStreak,
                        nudgeInProgress = nudgeInProgress,
                        startStreakInProgress = startStreakInProgress,
                        onStartSquadStreak = viewModel::startSquadStreak,
                        onNudgeSquadStreak = viewModel::nudgeSquadStreak,
                    )
                }

                composable(Tab.Picso.route) {
                    val viewModel = viewModel {
                        PicsoViewModel(
                            picsoRepository = container.picso,
                            loadChats = { container.chats.refresh(); container.chats.observeChats().first() },
                            sharedToChat = { navController.navigate(chatRoute(it)) { launchSingleTop = true } },
                        )
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()
                    val savedStateHandle = navController.currentBackStackEntry?.savedStateHandle
                    val justPublished by savedStateHandle?.getStateFlow("picso_published", false)?.collectAsStateWithLifecycle() ?: remember { mutableStateOf(false) }

                    LaunchedEffect(justPublished) {
                        if (justPublished) {
                            viewModel.refresh()
                            savedStateHandle?.set("picso_published", false)
                        }
                    }

                    PicsoScreen(
                        state = state,
                        navClearance = swetFloatingNavClearance(),
                        me = me,
                        onSwitchTab = viewModel::switchTab,
                        onRefresh = viewModel::refresh,
                        onLoadMore = viewModel::loadMore,
                        onSelectPost = viewModel::selectPost,
                        onReact = viewModel::react,
                        onToggleSave = viewModel::toggleSave,
                        onDeletePost = viewModel::deletePost,
                        onOpenCapture = { navController.navigate(PICSO_CAPTURE_ROUTE) },
                        onOpenProfile = { username -> navController.navigate(publicProfileRoute(username)) { launchSingleTop = true } },
                        onShare = viewModel::openShare,
                        onShareTo = viewModel::shareTo,
                        onDismissShare = viewModel::dismissShare,
                        loadImage = viewModel::image,
                        now = viewModel::now,
                        onReportPost = { picsoId ->
                            val post = state.selectedPost ?: state.items.firstOrNull { it.id == picsoId }
                            if (post != null && onReport != null) {
                                val targetUserId = UserId(post.authorId)
                                onReport(
                                    ReportRequest(
                                        target = ReportTarget.Picso(picsoId),
                                        account = ReportedAccount(
                                            userId = targetUserId,
                                            username = post.authorUsername,
                                            displayName = post.authorDisplayName,
                                        ),
                                    )
                                )
                            }
                        },
                    )
                }

                composable(PICSO_DETAIL_ROUTE) { entry ->
                    val picsoId = entry.arguments?.read { getStringOrNull("picsoId") }.orEmpty()
                    val viewModel = viewModel(key = "picso-$picsoId") {
                        PicsoViewModel(container.picso,
                            loadChats = { container.chats.refresh(); container.chats.observeChats().first() },
                            sharedToChat = { navController.navigate(chatRoute(it)) { launchSingleTop = true } })
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()
                    var requested by remember(picsoId) { mutableStateOf(false) }
                    LaunchedEffect(picsoId) { requested = true; viewModel.openPost(picsoId) }
                    Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                        if (!requested || state.isOpening) androidx.compose.material3.CircularProgressIndicator()
                        else if (state.actionError && state.selectedPost == null) {
                            androidx.compose.material3.TextButton(onClick = { viewModel.openPost(picsoId) }) {
                                Text(stringResource(Res.string.picso_error_load) + " · " + stringResource(Res.string.picso_retry))
                            }
                        }
                        else if (state.selectedPost == null) {
                            androidx.compose.material3.TextButton(onClick = { navController.popBackStack() }) {
                                Text(stringResource(Res.string.picso_error_expired))
                            }
                        }
                    }
                    state.selectedPost?.let { post ->
                        com.swetdot.swetgram.ui.picso.PicsoDetailViewer(
                            post = post, now = viewModel::now, loadImage = viewModel::image, busy = post.id in state.busyIds,
                            onDismiss = { navController.popBackStack() }, onReact = { viewModel.react(post.id, it) },
                            onToggleSave = { viewModel.toggleSave(post.id) }, onDelete = { viewModel.deletePost(post.id) },
                            onOpenProfile = { navController.navigate(publicProfileRoute(post.authorUsername)) { launchSingleTop = true } },
                            onShare = { viewModel.openShare(post) },
                            onReport = { onReport?.invoke(ReportRequest(ReportTarget.Picso(post.id), ReportedAccount(UserId(post.authorId), post.authorUsername, post.authorDisplayName))) },
                        )
                    }
                    com.swetdot.swetgram.ui.picso.PicsoSharePicker(state, me, viewModel::shareTo, viewModel::dismissShare)
                }

                composable(PICSO_CAPTURE_ROUTE) {
                    val viewModel = viewModel {
                        PicsoCaptureViewModel(
                            images = { container.imagePicker },
                            uploadRepository = container.uploads,
                            picsoRepository = container.picso,
                        )
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()

                    PicsoCaptureScreen(
                        state = state,
                        onSnapPhoto = viewModel::snapPhoto,
                        onCaptionChange = viewModel::onCaptionChanged,
                        onPublish = viewModel::publish,
                        onBack = { navController.popBackStack() },
                        onSuccess = {
                            navController.previousBackStackEntry?.savedStateHandle?.set("picso_published", true)
                            navController.popBackStack()
                        },
                    )
                }

                composable(Tab.Tasks.route) {
                    val viewModel = viewModel {
                        TasksViewModel(
                            tasks = container.tasks,
                            stepsSource = { container.dailyStepsSource },
                            realtime = container.realtime,
                        )
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()

                    LaunchedEffect(Unit) {
                        if (viewModel.state.value.loadedOnce) viewModel.refreshQuietly()
                    }

                    TasksScreen(
                        state = state,
                        onRefresh = viewModel::refresh,
                        onOpenTask = { destination ->
                            if (destination == DailyTaskDestination.STEP_PERMISSION) {
                                viewModel.requestStepsAccess()
                                return@TasksScreen
                            }
                            val target = when (destination) {
                                DailyTaskDestination.CHATS -> Tab.Chats
                                DailyTaskDestination.PICSO -> Tab.Picso
                                DailyTaskDestination.DISCOVER -> Tab.Picso
                                else -> null
                            }
                            if (target != null) {
                                navController.navigate(target.route) {
                                    popUpTo(navController.graph.startDestinationId) { saveState = true }
                                    launchSingleTop = true
                                    restoreState = true
                                }
                            }
                        },
                        onReplace = viewModel::replace,
                        onRequestStepsAccess = viewModel::requestStepsAccess,
                        onConfirmStepsAccess = viewModel::confirmStepsAccess,
                        onDismissStepsConsent = viewModel::dismissStepsConsent,
                        onDismissError = viewModel::dismissError,
                        onOpenShop = {
                            navController.navigate("shop") { launchSingleTop = true }
                        },
                    )
                }

                composable("shop") {
                    val viewModel = viewModel {
                        XpShopViewModel(
                            shop = container.xpShop,
                            tasks = container.tasks,
                        )
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()
                    XpShopScreen(
                        state = state,
                        onBack = { navController.popBackStack() },
                        onAskPurchase = viewModel::askConfirmPurchase,
                        onConfirmPurchase = viewModel::confirmPurchase,
                        onDismissConfirm = viewModel::dismissConfirm,
                        onDismissError = viewModel::dismissError,
                        onDismissNotice = viewModel::dismissNotice,
                    )
                }

                // SPS §7.1's groups tab, no longer a placeholder: the groups this user belongs to, and
                // the button that makes another one.
                composable(Tab.Groups.route) {
                    /*
                     * ALL ARGUMENTS ARE STATED, and three of them are what turn this tab from a
                     * list of names into the chat list the mockup asks for. Every one has a default,
                     * so `GroupsViewModel(container.groups)` compiles -- and gives a screen with no
                     * previews, no timestamps, no unread badges, no mute bells, no member grids and
                     * NO SEARCH FIELD AT ALL, because `GroupsUiState.canSearch` refuses to draw a box
                     * that swallows what is typed.
                     *
                     * THE CONVERSATIONS ARE THE POINT. The contract's `Group` carries a name, a
                     * description, a member count and a role, and not one of the five things a
                     * chat-list row is made of; those belong to the CONVERSATION under the group,
                     * which this client already caches for the Chats tab. `observeChats` is that
                     * cache, joined on `Group.conversationId`. No endpoint, no second read.
                     *
                     * `me` IS WHO 'I' AM, for `Chat.preview`'s "Me:" versus a member's name. Without
                     * it the row falls back to the group's own subtitle rather than guessing, because
                     * the tempting shortcut -- `UserId("")` -- attributes the reader's own messages
                     * to their sender.
                     */
                    val viewModel = viewModel {
                        GroupsViewModel(
                            container.groups,
                            container.chats.observeChats(archived = false),
                            GroupSearchCommands(container.api),
                            me,
                        )
                    }

                    // Re-read on every RETURN to this screen, gated on `loadedOnce` so the first entry
                    // does not fire a second read on top of the one `init` already started -- the same
                    // arrangement the Chats tab uses, and needed here for a sharper reason: coming back
                    // from the create flow, or from a group that was just left or deleted, is how this
                    // list changes. There is no cache and no realtime frame for groups, so without this
                    // the tab would keep showing a group the user is no longer in.
                    //
                    // `refreshQuietly`, NOT `refresh`, for the reason the Chats tab states above and
                    // with the same symptom: this block runs on every return, `refresh` raises
                    // `GroupsUiState.refreshing`, and `GroupsScreen` hands that straight to
                    // `PullToRefreshBox`. Both tabs the user named have this effect; Discover and
                    // Profile, which do not, were not in the report.
                    LaunchedEffect(Unit) {
                        if (viewModel.state.value.loadedOnce) viewModel.refreshQuietly()
                    }

                    val state by viewModel.state.collectAsStateWithLifecycle()
                    GroupsScreen(
                        state = state,
                        // The whole `Group`, because a group carries two ids of two different types.
                        // This route wants the GROUP id; the Chat row inside the group screen is what
                        // uses `conversationId`.
                        onOpenGroup = { group -> navController.navigate(groupRoute(group.id)) },
                        onCreateGroup = { navController.navigate(CREATE_GROUP_ROUTE) },
                        onRetry = viewModel::refresh,
                        onDismissError = viewModel::dismissError,
                        onRefresh = viewModel::refresh,
                        onLoadMore = viewModel::loadMore,
                        // The mockup's search field. Both defaults are INERT rather than absent, so
                        // omitting the first would have given a box that cannot be typed into --
                        // which is the one failure mode `canSearch` cannot catch, because the source
                        // is wired and the field therefore draws.
                        onQueryChange = viewModel::onQueryChange,
                        onRetrySearch = viewModel::retrySearch,
                    )
                }

                // SPS §12.2. A one-shot flow, like New Chat: it finishes by replacing itself with the
                // group it created, so Back from the group returns to the tab rather than to a form
                // that has already been submitted.
                composable(CREATE_GROUP_ROUTE) {
                    val viewModel = viewModel { CreateGroupViewModel(container.groups) }
                    val state by viewModel.state.collectAsStateWithLifecycle()

                    LaunchedEffect(state.created) {
                        val created = state.created ?: return@LaunchedEffect
                        // Consumed BEFORE navigating, exactly as the New Chat flow does: the field is a
                        // one-shot signal, and leaving it set would push the same group again on the
                        // next recomposition.
                        viewModel.consumeCreated()
                        navController.navigate(groupRoute(created.id)) {
                            popUpTo(CREATE_GROUP_ROUTE) { inclusive = true }
                        }
                    }

                    CreateGroupScreen(
                        state = state,
                        onFormChange = viewModel::onFormChange,
                        onSubmit = viewModel::submit,
                        onBack = { navController.popBackStack() },
                        onDismissBanner = viewModel::dismissBanner,
                    )
                }

                composable(GROUP_ROUTE) { entry ->
                    val groupId = GroupId(
                        entry.arguments?.read { getStringOrNull(GROUP_ID_ARG) }.orEmpty(),
                    )
                    val viewModel = viewModel(key = groupId.value) {
                        GroupViewModel(groupId, container.groups)
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()

                    // Left or deleted. Consumed before the pop, for the reason every other one-shot
                    // signal in this file is: a recomposition would otherwise pop a second screen.
                    LaunchedEffect(state.exited) {
                        if (!state.exited) return@LaunchedEffect
                        viewModel.consumeExited()
                        navController.popBackStack()
                    }

                    GroupScreen(
                        state = state,
                        onBack = { navController.popBackStack() },
                        // THE POINT OF PASS 1'S SCHEMA DECISION. A group's chat is a conversation, so
                        // this is the SAME destination a direct message opens -- no group-specific
                        // conversation screen exists, and none should. The id is the conversation's,
                        // not the group's.
                        onOpenChat = { chatId ->
                            navController.navigate(chatRoute(chatId)) { launchSingleTop = true }
                        },
                        // SPS §12.1's middle section, between Chat and Members, which is the order SDS
                        // §14.1 gives and the order the rows are drawn in. Required with no default on
                        // `GroupScreen`, deliberately: a row that leads nowhere is how a third of the
                        // group model ships invisible.
                        onOpenDiscover = null,
                        // No argument: the members route is keyed by the GROUP id, which this entry
                        // already holds from its own route.
                        onOpenMembers = { navController.navigate(groupMembersRoute(groupId)) },
                        // The three pass-3 surfaces, all keyed by the same group id and all gated by
                        // the SCREEN rather than here: `GroupUiState.canOpenInviteLink`,
                        // `canOpenJoinRequests` and `canOpenBans` decide whether the row is drawn at
                        // all. A permission check repeated in this file would be a second copy of a
                        // rule the server owns -- and the copy that drifts is the one that shows a row
                        // leading straight to a 403.
                        onOpenInviteLink = { navController.navigate(groupInviteRoute(groupId)) },
                        onOpenJoinRequests = { navController.navigate(groupJoinRequestsRoute(groupId)) },
                        onOpenBans = { navController.navigate(groupBansRoute(groupId)) },
                        onOpenSettings = { navController.navigate(groupSettingsRoute(groupId)) },
                        onShowQr = viewModel::showQr,
                        onDismissQr = viewModel::dismissQr,
                        onJoin = viewModel::join,
                        onLeave = viewModel::leave,
                        onDelete = viewModel::deleteGroup,
                        onRetry = viewModel::refresh,
                        onDismissError = viewModel::dismissError,
                        // SPS §16.3's fifth target. THE ONE THE SDS NAMES NO CONTROL FOR anywhere --
                        // §16.3 lists groups among the reportable things and the design folder never
                        // says where the action goes, so the screen's placement is a DECISION and says
                        // so. The owner does not see it; there is nobody to report a group to but its
                        // owner.
                        onReport = onReport,
                    )
                }

                composable(GROUP_SETTINGS_ROUTE) { entry ->
                    val groupId = GroupId(
                        entry.arguments?.read { getStringOrNull(GROUP_ID_ARG) }.orEmpty(),
                    )
                    val viewModel = viewModel(key = "settings:${groupId.value}") {
                        GroupSettingsViewModel(groupId, container.groups)
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()
                    GroupSettingsScreen(
                        state = state,
                        onFormChange = viewModel::onFormChange,
                        onSave = viewModel::save,
                        onBack = { navController.popBackStack() },
                        onRetry = viewModel::refresh,
                        onDismissMessage = viewModel::dismissMessage,
                    )
                }

                composable(GROUP_MEMBERS_ROUTE) { entry ->
                    val groupId = GroupId(
                        entry.arguments?.read { getStringOrNull(GROUP_ID_ARG) }.orEmpty(),
                    )
                    val viewModel = viewModel(key = groupId.value) {
                        GroupMembersViewModel(groupId, container.groups, me)
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()
                    GroupMembersScreen(
                        state = state,
                        // The session's own id, passed as `ChatListScreen` takes it, so a row can be
                        // marked "You" and never offered a removal.
                        me = me,
                        onBack = { navController.popBackStack() },
                        onQueryChange = viewModel::onQueryChange,
                        // Keyed by username, the same public profile every other caller opens.
                        onOpenProfile = { username ->
                            navController.navigate(publicProfileRoute(username)) { launchSingleTop = true }
                        },
                        onRemove = viewModel::remove,
                        // `banGroupMember`, kept SEPARATE from `onRemove` all the way down: two writes
                        // with two different consequences, and only one of them can be lifted from the
                        // group's ban list. Collapsing them into one callback with a flag is how a
                        // confirmation dialog ends up promising the reversible one and sending the
                        // other.
                        onBan = viewModel::ban,
                        onChangeRole = viewModel::changeRole,
                        onTransferOwnership = viewModel::transferOwnership,
                        onRetry = viewModel::refresh,
                        onDismissError = viewModel::dismissError,
                        onLoadMore = viewModel::loadMore,
                    )
                }

                /**
                 * SPS §12.3's invite link. Its own route rather than a dialog off the group screen,
                 * because what it shows is a credential and the only way to see one is a call that may
                 * INVALIDATE the link the group has already shared.
                 */
                composable(GROUP_INVITE_ROUTE) { entry ->
                    val groupId = GroupId(
                        entry.arguments?.read { getStringOrNull(GROUP_ID_ARG) }.orEmpty(),
                    )
                    val viewModel = viewModel(key = groupId.value) {
                        GroupInviteViewModel(groupId, container.groups)
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()
                    GroupInviteScreen(
                        state = state,
                        onBack = { navController.popBackStack() },
                        onCreateOrRotate = viewModel::createOrRotate,
                        onRetry = viewModel::refresh,
                        onDismissError = viewModel::dismissError,
                    )
                }

                /** A private group's approval queue. Owner and Admin; the row is hidden otherwise. */
                composable(GROUP_JOIN_REQUESTS_ROUTE) { entry ->
                    val groupId = GroupId(
                        entry.arguments?.read { getStringOrNull(GROUP_ID_ARG) }.orEmpty(),
                    )
                    val viewModel = viewModel(key = groupId.value) {
                        GroupJoinRequestsViewModel(groupId, container.groups)
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()
                    GroupJoinRequestsScreen(
                        state = state,
                        onBack = { navController.popBackStack() },
                        onResolve = viewModel::resolve,
                        onRetry = viewModel::refresh,
                        onDismissError = viewModel::dismissError,
                        onLoadMore = viewModel::loadMore,
                    )
                }

                /** The ban list -- the only surface in the app from which a ban can be lifted. */
                composable(GROUP_BANS_ROUTE) { entry ->
                    val groupId = GroupId(
                        entry.arguments?.read { getStringOrNull(GROUP_ID_ARG) }.orEmpty(),
                    )
                    val viewModel = viewModel(key = groupId.value) {
                        GroupBansViewModel(groupId, container.groups)
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()
                    GroupBansScreen(
                        state = state,
                        onBack = { navController.popBackStack() },
                        onUnban = viewModel::unban,
                        onRetry = viewModel::refresh,
                        onDismissError = viewModel::dismissError,
                        onLoadMore = viewModel::loadMore,
                    )
                }

                /**
                 * Where an invite link lands: `previewGroupInvite`, then `actOnGroupInvite`.
                 *
                 * THE ONLY DESTINATION IN THIS FILE REACHABLE FROM OUTSIDE THE APP, which shapes three
                 * things that look like fussiness and are not:
                 *
                 *  * BACK GOES TO THE CHATS TAB, not to `popBackStack()`. On a cold start from a link
                 *    this screen IS the back stack, and popping an empty one closes the app -- so a
                 *    user who decided not to join would be thrown out of Swetgram for declining. The
                 *    pop is attempted first and the tab is the fallback, so an in-app arrival still
                 *    returns where it came from.
                 *  * THE JOINED SIGNAL REPLACES THIS SCREEN with the group, `inclusive = true`. Leaving
                 *    the invite on the stack would let Back return to a preview whose only button now
                 *    says "Open" for a group the user is already in.
                 *  * THE TOKEN IS READ VERBATIM. No trim, no lowercase, no decode: it is a
                 *    case-sensitive credential and the route matcher has already given us exactly one
                 *    path segment.
                 */
                composable(LINK_RESOLVER_ROUTE) { entry ->
                    val kind = entry.arguments?.read { getStringOrNull(LINK_KIND_ARG) }
                        ?.uppercase()
                        ?.let { runCatching { ExternalLinkKind.valueOf(it) }.getOrNull() }
                    val value = entry.arguments?.read { getStringOrNull(LINK_VALUE_ARG) }.orEmpty()
                    val link = kind?.let { ExternalLink(it, value) }
                    val leave = {
                        if (!navController.popBackStack()) navController.navigate(Tab.Chats.route)
                        Unit
                    }

                    if (link == null) {
                        LinkResolverScreen(
                            state = com.swetdot.swetgram.ui.links.LinkResolverUiState(
                                loading = false,
                                failed = true,
                            ),
                            onBack = leave,
                            onRetry = leave,
                        )
                    } else {
                        val viewModel = viewModel(key = "${kind.name}:$value") {
                            LinkResolverViewModel(link, container.links)
                        }
                        val state by viewModel.state.collectAsStateWithLifecycle()

                        LaunchedEffect(state.resolved) {
                            val resolved = state.resolved ?: return@LaunchedEffect
                            val destination = when (resolved.type) {
                                ResolvedLinkType.USER_PROFILE ->
                                    resolved.username?.let(::publicProfileRoute)
                                ResolvedLinkType.PUBLIC_GROUP ->
                                    resolved.targetId?.let { groupRoute(GroupId(it)) }
                                ResolvedLinkType.PRIVATE_GROUP_INVITE,
                                ResolvedLinkType.UNKNOWN,
                                -> null
                            }
                            if (destination != null) {
                                navController.navigate(destination) {
                                    popUpTo(LINK_RESOLVER_ROUTE) { inclusive = true }
                                }
                            }
                        }

                        LinkResolverScreen(
                            state = state,
                            onBack = leave,
                            onRetry = viewModel::resolve,
                        )
                    }
                }

                composable(JOIN_GROUP_ROUTE) { entry ->
                    val token = entry.arguments?.read { getStringOrNull(INVITE_TOKEN_ARG) }.orEmpty()
                    val viewModel = viewModel(key = token) {
                        JoinGroupViewModel(token, container.groups)
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()

                    val leave = {
                        if (!navController.popBackStack()) {
                            navController.navigate(Tab.Chats.route) {
                                popUpTo(JOIN_GROUP_ROUTE) { inclusive = true }
                            }
                        }
                        Unit
                    }

                    JoinGroupScreen(
                        state = state,
                        onBack = leave,
                        onAct = viewModel::act,
                        // The one-shot join signal. Unlike the create-group and leave-group flows, the
                        // `LaunchedEffect` that watches it lives in the SCREEN, so this file supplies
                        // the effect rather than owning it -- and must still consume BEFORE navigating,
                        // or `joinedGroupId` stays set and the next recomposition pushes the group a
                        // second time.
                        onJoined = { joined ->
                            viewModel.consumeJoined()
                            navController.navigate(groupRoute(joined)) {
                                popUpTo(JOIN_GROUP_ROUTE) { inclusive = true }
                            }
                        },
                        onRetry = viewModel::refresh,
                        onDismissError = viewModel::dismissError,
                    )
                }

                composable(Tab.Profile.route) {
                    val viewModel = viewModel { MyProfileViewModel(container.profiles) }
                    val profile by viewModel.profile.collectAsStateWithLifecycle()
                    val error by viewModel.error.collectAsStateWithLifecycle()
                    val loadedOnce by viewModel.loadedOnce.collectAsStateWithLifecycle()
                    val qr by viewModel.qr.collectAsStateWithLifecycle()
                    ProfileScreen(
                        profile = profile,
                        onEditProfile = { navController.navigate(EDIT_PROFILE_ROUTE) },
                        onOpenSettings = { navController.navigate(SETTINGS_ROUTE) },
                        error = error,
                        onRetry = viewModel::refresh,
                        loadedOnce = loadedOnce,
                        qr = qr,
                        onShowQr = viewModel::showQr,
                        onDismissQr = viewModel::dismissQr,
                    )
                }

                composable(EDIT_PROFILE_ROUTE) {
                    val viewModel = viewModel {
                        EditProfileViewModel(
                            container.profiles,
                            // Read on the tap, for the reason the conversation screen gives above.
                            images = { container.imagePicker },
                            uploads = container.uploads,
                        )
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()
                    EditProfileScreen(
                        state = state,
                        onSave = viewModel::save,
                        onBack = { navController.popBackStack() },
                        onChangeAvatar = viewModel::changeAvatar,
                        // The screen raises this once the save lands. Consuming the flag before
                        // popping keeps a recomposition from firing the navigation twice.
                        onSaved = {
                            viewModel.consumeSaved()
                            navController.popBackStack()
                        },
                        onRetry = viewModel::refresh,
                    )
                }

                composable(SETTINGS_ROUTE) {
                    val viewModel = viewModel { SettingsViewModel(container.profiles, container.auth) }
                    val state by viewModel.state.collectAsStateWithLifecycle()
                    SettingsScreen(
                        state = state,
                        appVersionLabel = when (container.clientInfo.platform) {
                            "ios" -> "iOS ${container.clientInfo.version}"
                            else -> "Android ${container.clientInfo.version}"
                        },
                        onBack = { navController.popBackStack() },
                        onEditProfile = { navController.navigate(EDIT_PROFILE_ROUTE) },
                        onPrivacy = { navController.navigate(PRIVACY_ROUTE) },
                        onBlockedUsers = { navController.navigate(BLOCKED_USERS_ROUTE) },
                        // No navigation of our own: dropping the session flips the gate in `App.kt`,
                        // which swaps the whole frame for the sign-in flow. Popping here as well
                        // would animate a back transition on a stack that is about to be discarded.
                        onSignOut = viewModel::signOut,
                        onRequestDeletion = viewModel::requestDeletion,
                        onCancelDeletion = viewModel::cancelDeletion,
                        onRetry = viewModel::refresh,
                        onDismissError = viewModel::dismissError,
                        onNotifications = { navController.navigate(NOTIFICATIONS_ROUTE) },
                        onPremium = { navController.navigate(PREMIUM_ROUTE) },
                        // SPS §16.4's panel, and the ONLY entrance to it anywhere in the app.
                        //
                        // Passed UNCONDITIONALLY, and the screen still shows it to nobody but staff:
                        // `SettingsScreen` applies `canOpenModeration` to the role `getMe` actually
                        // returned before it draws the row. That second lock lives there rather than
                        // here on purpose -- a host that forgot the check must not be able to reveal
                        // the panel's existence, and this file has no role to check against anyway
                        // (`me` here is an id, not a profile).
                        //
                        // It is a convenience either way. The server answers `403 admin_role_required`
                        // to every non-staff account whatever this client draws, and the two screens
                        // behind this route render that refusal as terminal rather than as a failure to
                        // retry.
                        onModeration = { navController.navigate(MODERATION_ROUTE) },
                    )
                }

                /**
                 * SPS §16.4's report queue -- `adminListReports`, newest first, filtered to `open` by
                 * default because that is what makes the screen a QUEUE rather than an archive.
                 *
                 * RE-READ ON EVERY RETURN, like the Chats and Groups tabs and unlike Discover, and here
                 * it is not a nicety: the way this list changes is a moderator deciding a report on the
                 * screen behind it, and the default filter is `open`, so without this the queue comes
                 * back still showing the report that was just resolved. There is no cache, no realtime
                 * frame and no push for reports -- nothing else could tell it.
                 *
                 * Gated on `loadedOnce` so the FIRST entry does not fire a second read on top of the one
                 * the view model's own `init` already started.
                 */
                composable(MODERATION_ROUTE) {
                    val viewModel = viewModel {
                        // `asModerationSource()` is the one-line adapter that keeps the view models
                        // constructible without a network -- `AdminRepository` itself needs an
                        // `ApiClient`, and a queue whose paging and 403 handling could only be
                        // exercised against a live server is a queue whose corners never get tested.
                        ModerationQueueViewModel(container.admin.asModerationSource())
                    }

                    LaunchedEffect(Unit) {
                        if (viewModel.state.value.loadedOnce) viewModel.refresh()
                    }

                    val state by viewModel.state.collectAsStateWithLifecycle()

                    ModerationQueueScreen(
                        state = state,
                        onBack = { navController.popBackStack() },
                        // The whole row, because the screen holds it; only the id crosses into the
                        // route. The detail screen re-reads through `adminGetReport` rather than
                        // carrying the row across -- a queue is a snapshot, and a colleague may have
                        // decided this one while it sat on screen.
                        onOpenReport = { report -> navController.navigate(moderationReportRoute(report.id)) },
                        onSetFilter = viewModel::setFilter,
                        onRefresh = viewModel::refresh,
                        onLoadMore = viewModel::loadMore,
                        onDismissError = viewModel::dismissError,
                    )
                }

                /**
                 * One report, and the decision form. `adminGetReport` then `adminResolveReport`.
                 *
                 * BOTH DECISIONS ARE TERMINAL and two of the three side effects destroy something that
                 * cannot be brought back, so the screen confirms before it sends -- SDS §11.1. Nothing
                 * about that is decided here; this route supplies the id and takes the pop.
                 */
                composable(MODERATION_REPORT_ROUTE) { entry ->
                    val reportId = entry.arguments?.read { getStringOrNull(REPORT_ID_ARG) }.orEmpty()
                    val viewModel = viewModel(key = reportId) {
                        ModerationReportViewModel(reportId, container.admin.asModerationSource())
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()

                    // Decided. Consumed BEFORE popping, exactly as every other one-shot signal in this
                    // file is -- leaving it set pops a second screen on the next recomposition.
                    LaunchedEffect(state.decided) {
                        if (!state.decided) return@LaunchedEffect
                        viewModel.consumeDecided()
                        navController.popBackStack()
                    }

                    ModerationReportScreen(
                        state = state,
                        onBack = { navController.popBackStack() },
                        onRefresh = viewModel::refresh,
                        onResolve = viewModel::resolve,
                        onDismissError = viewModel::dismissError,
                    )
                }

                composable(PRIVACY_ROUTE) {
                    val viewModel = viewModel { PrivacyViewModel(container.privacy) }
                    val settings by viewModel.settings.collectAsStateWithLifecycle()
                    val error by viewModel.error.collectAsStateWithLifecycle()
                    val loadedOnce by viewModel.loadedOnce.collectAsStateWithLifecycle()
                    PrivacyScreen(
                        settings = settings,
                        onChange = viewModel::update,
                        onBack = { navController.popBackStack() },
                        onBlockedUsers = { navController.navigate(BLOCKED_USERS_ROUTE) },
                        // `PrivacyViewModel` carries a `UiText` now; `PrivacyScreen` still takes the
                        // words. Resolved here rather than pushing the change into a screen this pass
                        // does not own -- the screen migrates with the rest of its package.
                        error = error.resolveOrNull(),
                        onRetry = viewModel::refresh,
                        onDismissError = viewModel::dismissError,
                        loadedOnce = loadedOnce,
                    )
                }

                composable(BLOCKED_USERS_ROUTE) {
                    val viewModel = viewModel { BlockedUsersViewModel(container.blocks) }
                    val state by viewModel.state.collectAsStateWithLifecycle()
                    BlockedUsersScreen(
                        state = state,
                        onUnblock = viewModel::unblock,
                        onBack = { navController.popBackStack() },
                        onRetry = viewModel::refresh,
                        onDismissError = viewModel::dismissError,
                        onLoadMore = viewModel::loadMore,
                    )
                }

                composable(PUBLIC_PROFILE_ROUTE) { entry ->
                    val username = entry.arguments?.read { getStringOrNull(USERNAME_ARG) }.orEmpty()
                    val viewModel = viewModel(key = username) {
                        // NO REPORT SUBMITTER HERE ANY MORE, and its absence is the opposite of what it
                        // used to be. This view model once owned reporting and could not do it, because
                        // `POST /reports` had no wire type and no server behind it. Both exist now, and
                        // reporting moved OUT of here into `ui/moderation` -- one flow for all five of
                        // SPS §16.3's targets rather than a fifth copy of a seven-item reason list. What
                        // this screen keeps is the Report BUTTON, wired below.
                        PublicProfileViewModel(
                            username = username,
                            profiles = container.profiles,
                            blocks = container.blocks,
                            chats = container.chats,
                        )
                    }
                    val state by viewModel.state.collectAsStateWithLifecycle()

                    // SPS §13.2's Message button, which used to be wired to an empty lambda: the
                    // largest, most saturated control in the app did nothing at all when tapped.
                    // `createOrGetDirect` answers with the existing conversation or a new one, and
                    // this opens it.
                    LaunchedEffect(state.openChatId) {
                        val opened = state.openChatId ?: return@LaunchedEffect
                        // Consumed BEFORE navigating, exactly as the New Chat flow does: the flag is a
                        // one-shot signal and leaving it set would push the conversation again on the
                        // next recomposition.
                        viewModel.consumeOpened()
                        navController.navigate(chatRoute(opened))
                    }

                    PublicProfileScreen(
                        state = state,
                        onBack = { navController.popBackStack() },
                        onMessage = viewModel::openChat,
                        onBlock = viewModel::block,
                        onUnblock = viewModel::unblock,
                        onShowQr = viewModel::showQr,
                        onDismissQr = viewModel::dismissQr,
                        onRetry = viewModel::refresh,
                        onDismissError = viewModel::dismissError,
                        // SPS §16.3's `user` target, and SDS §11.1's "Report user" -- the one report
                        // control the design folder names by that exact phrase. The sheet it opens
                        // offers SPS §16.2's block on its receipt, which is the same `blockUser` call
                        // the Block button above it makes; one implementation, two entrances.
                        onReport = onReport,
                    )
                }
                }
            }

            androidx.compose.animation.AnimatedVisibility(
                visibleState = bottomNavVisibility,
                enter = fadeIn(tween(fastTransitionMillis, easing = SwetEasing.enter)) +
                    slideInVertically(
                        tween(fastTransitionMillis, easing = SwetEasing.enter),
                        initialOffsetY = { it / 2 },
                    ),
                exit = fadeOut(tween(fastTransitionMillis, easing = SwetEasing.exit)) +
                    slideOutVertically(
                        tween(fastTransitionMillis, easing = SwetEasing.exit),
                        targetOffsetY = { it / 2 },
                    ),
                modifier = Modifier.align(Alignment.BottomCenter),
            ) {
                // Resolved HERE, where the bar is drawn, because this is the first composable scope the
                // labels reach: `Tab` carries the `StringResource` and cannot look it up itself.
                //
                // A `for` loop rather than `Tab.entries.map { }` for the reason `UiText.resolve` gives
                // about its own loop: whether a composable call may sit inside a stdlib lambda depends
                // on that lambda being inlined, which is a property of the standard library rather than
                // of anything written here. The loop needs no such argument.
                val navTabs = ArrayList<SwetNavTab>(Tab.entries.size)
                for (tab in Tab.entries) {
                    navTabs.add(
                        SwetNavTab(
                            label = stringResource(tab.label),
                            icon = { tint -> TabGlyph(tab.glyph, tint) },
                        ),
                    )
                }

                SwetBottomNav(
                    tabs = navTabs,
                    selectedIndex = selectedIndex,
                    onSelect = { index ->
                        val target = Tab.entries[index].route
                        val settled = navController.currentBackStackEntry
                            ?.lifecycle
                            ?.currentState == Lifecycle.State.RESUMED
                        if (!settled || target == current) return@SwetBottomNav
                        navController.navigate(target) {
                            // Switching tabs must not pile destinations onto the back stack,
                            // and returning to a tab should restore where the user was
                            // rather than resetting it to the top.
                            popUpTo(navController.graph.startDestinationId) { saveState = true }
                            launchSingleTop = true
                            restoreState = true
                        }
                    },
                    modifier = Modifier.swetTransitionTarget(showBottomNav),
                    // Inside the same `Box` as the NavHost and drawn after it, which is what makes the
                    // bar FLOAT rather than sit in the layout. ON ALL ROOT TABS the screen's own
                    // content runs underneath it now and each screen reserves the room in its own
                    // scroll padding -- see the note above `frameBackground` for what that replaced.
                )
            }
        }

        // SPS §16.3's report sheet, drawn OVER the whole frame rather than inside any destination.
        //
        // It is a `Dialog`, so it occupies no space in this `Column` and renders nothing at all
        // while no report is open -- `ReportSheetHost` returns early on a null request. Hosting it
        // here rather than in each of the five reportable screens is what makes one flow serve all
        // of them, and what keeps the sheet on screen if the surface underneath goes away.
        ReportSheetHost(viewModel = reportViewModel)
    }
}

/**
 * SPS §11.6's comment thread, as a sheet over whichever Discover feed opened it.
 *
 * ONE HOST FOR BOTH FEEDS. The Discover tab and a group's Discover area both open comments, and the
 * wiring is not trivial -- a view model with four collaborators, two one-shot signals to consume and
 * a scope that has to be got exactly right. Written twice it would drift, and the half that drifted
 * would be the group feed, which nobody opens on the way to anything else.
 *
 * THE VIEW MODEL'S SCOPE IS THE WHOLE POINT OF THIS BEING A COMPOSABLE RATHER THAN A LAMBDA. It is
 * resolved from `LocalViewModelStoreOwner`, which inside a `composable(...)` block is that route's
 * `NavBackStackEntry` -- so the model belongs to the FEED and not to this function. Two consequences,
 * both required by `PostDetailUiState.draft` holding the comment somebody is typing:
 *
 *  * closing the sheet does not clear it, because this composable leaving composition does not clear
 *    a store it does not own -- reopening the same post finds the words still there;
 *  * an Activity recreation does not clear it either, for the same reason the route's own copy
 *    survives one.
 *
 * `createDiscoverComment` carries no `Idempotency-Key` and no `client_id`, so a failed send may never
 * be retried automatically and must therefore never lose the text. That is the whole reason the draft
 * is in the model rather than in a `remember`, and this scope is what makes that true in practice.
 *
 * THE COST, stated: a model per post opened, alive until the feed's entry is destroyed. A reader who
 * opens thirty threads in one visit to the tab leaves thirty behind, each holding a page of comments.
 * Bounded by one visit and small, and the alternative is a draft that evaporates when the sheet
 * closes.
 *
 * `key` IS PREFIXED, and that is not decoration. `POST_DETAIL_ROUTE` builds its own model with
 * `key = postId.value`; these are different store owners today, so nothing collides -- but the
 * failure if they ever shared one is a `ClassCastException` at the moment the second is asked for,
 * which is the trap `GROUP_DISCOVER_ROUTE` already records against its own two models.
 */
@Composable
private fun CommentsSheetHost(
    postId: DiscoverPostId,
    container: AppContainer,
    me: UserId,
    onDismiss: () -> Unit,
    onOpenProfile: (String) -> Unit,
    onOpenChat: (ChatId) -> Unit,
    onReport: ((ReportRequest) -> Unit)?,
    /** The reader's own disc on the composer. Null draws none -- see [rememberComposerAuthor]. */
    author: CommentComposerAuthor?,
) {
    val viewModel = viewModel(key = "comments-${postId.value}") {
        PostDetailViewModel(
            postId = postId,
            // Every ownership question in the thread is asked against it: whose comment carries Edit
            // and Delete, and whose may only be reported.
            me = me,
            source = container.discover.asPostDetailSource(),
            chats = container.chats,
            realtime = container.realtime,
        )
    }
    val state by viewModel.state.collectAsStateWithLifecycle()

    // The POST was deleted, by this reader or out from under them. The route pops itself here; the
    // sheet closes, which is the same act on a surface that is not a destination. Consumed before
    // acting, for the reason every one-shot signal in this file is.
    LaunchedEffect(state.dismissed) {
        if (!state.dismissed) return@LaunchedEffect
        viewModel.consumeDismissed()
        onDismiss()
    }

    // SPS §5.1's "message author from a Discover post", reachable from a comment's author here.
    // THE SAME `createOrGetDirect` destination the public profile opens.
    LaunchedEffect(state.openChatId) {
        val opened = state.openChatId ?: return@LaunchedEffect
        viewModel.consumeOpened()
        onOpenChat(opened)
    }

    CommentsSheet(
        state = state,
        onDismiss = onDismiss,
        onRefresh = viewModel::refresh,
        onLoadMore = viewModel::loadMore,
        onDraftChange = viewModel::onDraftChange,
        onSend = viewModel::sendComment,
        onSetCommentLiked = viewModel::setCommentLiked,
        onReply = viewModel::beginReply,
        onCancelReply = viewModel::cancelReply,
        onBeginEditComment = viewModel::beginEditComment,
        onEditDraftChange = viewModel::onEditDraftChange,
        onSaveEdit = viewModel::saveEdit,
        onCancelEdit = viewModel::cancelEdit,
        onDeleteComment = viewModel::deleteComment,
        onAcceptAnswer = viewModel::acceptAnswer,
        onClearAcceptedAnswer = viewModel::clearAcceptedAnswer,
        onOpenProfile = onOpenProfile,
        onDismissError = viewModel::dismissError,
        onDismissNotice = viewModel::dismissNotice,
        // One of SPS §16.3's five targets: each comment in the thread. The POST's own report stays
        // on the feed card's overflow and on the detail route's bar, because the post is not drawn
        // inside the sheet -- it is the card still visible behind the scrim.
        onReport = onReport,
        author = author,
    )
}

/**
 * Who the comment composer's disc belongs to, fetched at most once per app session and only if a
 * comment sheet is ever opened.
 *
 * IT IS A REQUEST, AND THAT IS WHY IT IS GATED. `PostDetailViewModel` holds only a `UserId` -- every
 * question it asks with it is about ownership -- and giving it a profile source to satisfy one avatar
 * would put a network dependency into a screen that had none. There is no cached `MyProfile` anywhere
 * in this client: `ProfileRepository.me()` is a live `GET /users/me` and the Profile tab is the only
 * thing that has ever called it.
 *
 * So the read is deferred behind [request], which the sheet host fires when it first composes. A user
 * who never opens comments never makes this call, and a user who opens twenty threads makes it once.
 *
 * FAILURE IS NULL AND NULL DRAWS NO DISC, rather than a grey circle asserting somebody exists. There
 * is nothing here worth a banner: the composer works without it, and a reader who cannot see their
 * own face on their own keyboard row has lost nothing they were about to act on. Silent by design,
 * which is the one case in this app where swallowing a failure is the right answer.
 *
 * @return the identity, and the lambda that asks for it. Reading it before asking gives null.
 */
@Composable
private fun rememberComposerAuthor(container: AppContainer): Pair<CommentComposerAuthor?, () -> Unit> {
    var author by remember { mutableStateOf<CommentComposerAuthor?>(null) }
    var asked by remember { mutableStateOf(false) }

    LaunchedEffect(asked) {
        if (!asked || author != null) return@LaunchedEffect
        author = runCatching { container.profiles.me() }
            .getOrNull()
            ?.let { CommentComposerAuthor(it.user.displayName, it.user.avatarUrl) }
    }

    return author to { asked = true }
}
